var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmovLogoVgr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 30,
    viewBox: "0 0 62 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5977 6.16879L18.0651 8.60479L6.31656 20.2038V6.16879H-0.265022V28.9594H3.58236C5.33304 28.9594 7.01201 28.2728 8.24997 27.0504L22.4994 12.9826L24.9668 15.4186V6.16879H15.5977Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.008 14.192C36.27 14.588 35.532 14.732 34.74 14.732C32.328 14.732 30.654 13.058 30.654 10.7C30.654 8.306 32.328 6.668 34.776 6.668C36.054 6.668 37.116 7.118 38.034 8.09L39.906 6.362C38.682 4.94 36.846 4.184 34.632 4.184C30.618 4.184 27.702 6.902 27.702 10.7C27.702 14.498 30.618 17.216 34.578 17.216C36.378 17.216 38.286 16.658 39.672 15.614V10.502H37.008V14.192ZM55.3407 17L52.5147 12.95C54.1527 12.248 55.1067 10.862 55.1067 8.972C55.1067 6.146 53.0007 4.4 49.6347 4.4H44.1807V17H47.0967V13.49H49.6347H49.7787L52.2087 17H55.3407ZM52.1547 8.972C52.1547 10.34 51.2547 11.168 49.4727 11.168H47.0967V6.776H49.4727C51.2547 6.776 52.1547 7.586 52.1547 8.972Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmovLogoVgr);
export default __webpack_public_path__ + "static/media/tmov-logo-vgr.68b00bf2a7629264ecef3309fcc45008.svg";
export { ForwardRef as ReactComponent };